import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { Shield, Lock, CreditCard, Zap, Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="bg-cream py-16 px-4 relative overflow-hidden border-t border-border" data-id="element-154">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-gold/5 rounded-full blur-[150px] pointer-events-none" data-id="element-155"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-156">
        <div className="text-center mb-10" data-id="element-157">
          <h2 className="text-lg md:text-2xl font-bold mb-4 flex items-center justify-center text-primary tracking-wide" data-id="element-158">
            <span className="mr-2" data-id="element-159">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <Countdown data-id="element-160" />
          <p className="text-ink mt-4 flex items-center justify-center text-sm md:text-base font-bold bg-urgency/10 inline-flex px-4 py-2 rounded-full border border-urgency/20" data-id="element-161">
            <span className="text-urgency mr-2" data-id="element-162">⚠️</span> Después sube $8.000
            ARS. No vuelve.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-12" data-id="element-163">
          <div className="flex justify-between text-sm mb-2 text-ink font-bold" data-id="element-164">
            <span className="flex items-center" data-id="element-165">
              <span className="w-2 h-2 rounded-full bg-urgency mr-2 animate-pulse" data-id="element-166"></span>
              Cupos al precio de lanzamiento
            </span>
            <span data-id="element-167">68%</span>
          </div>
          <div className="w-full bg-surface rounded-full h-3 overflow-hidden border border-border" data-id="element-168">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-primary to-urgency h-3 rounded-full" data-id="element-169"></motion.div>
          </div>
          <p className="text-xs text-center text-muted mt-2 font-medium" data-id="element-170">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h3 className="text-2xl md:text-4xl font-bold text-center text-ink mb-8 flex items-center justify-center font-serif" data-id="element-171">
          <CreditCard className="w-6 h-6 md:w-8 md:h-8 mr-3 text-primary" data-id="element-172" />{' '}
          ELEGÍ TU PLAN
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-173">
          <motion.div whileHover={{
          y: -8
        }} className="bg-white rounded-2xl p-6 md:p-8 border border-border flex flex-col h-full shadow-md" data-id="element-174">
            <div className="text-center mb-6" data-id="element-175">
              <h4 className="text-xl md:text-2xl font-bold text-ink mb-2 flex items-center justify-center font-serif" data-id="element-176">
                <span className="mr-2" data-id="element-177">📘</span> DOMINIO FINANCIERO
              </h4>
              <p className="text-muted font-bold text-sm md:text-base mb-4" data-id="element-178">
                6 Tomos + 6 Bonos
              </p>
              <div className="bg-surface rounded-xl py-3 px-4 inline-block mb-2 border border-border/50" data-id="element-179">
                <p className="text-xs text-muted mb-1 uppercase tracking-wider font-bold" data-id="element-180">
                  Ideal para:
                </p>
                <p className="text-sm font-medium text-ink" data-id="element-181">
                  Personas que quieren ordenar, proteger y empezar a hacer
                  crecer su dinero en Argentina
                </p>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-182">
              <p className="line-through text-base md:text-lg mb-2 text-muted font-medium" data-id="element-183">
                $53.000
              </p>
              <div className="flex items-start justify-center" data-id="element-184">
                <span className="text-xl md:text-2xl text-ink mt-1 mr-1 font-bold" data-id="element-185">
                  $
                </span>
                <span className="text-4xl md:text-6xl font-bold text-ink font-serif" data-id="element-186">
                  19.990
                </span>
                <span className="text-sm md:text-xl text-ink mt-auto mb-2 ml-1 font-bold" data-id="element-187">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://www.digitalbibliotec.online/cart/52265760915738:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#F2D87A] via-[#C9A84C] to-[#8A6E2A] hover:from-[#F5DE8C] hover:via-[#D4B45A] hover:to-[#9A7E36] text-ink border border-[#8A6E2A]/50 font-bold py-4 px-6 rounded-full transition-all text-center text-sm md:text-base shadow-[0_8px_20px_rgba(138,110,42,0.35),inset_0_1px_0_rgba(255,255,255,0.5)] hover:scale-[1.02] active:scale-95" data-id="element-188">
              👉 QUIERO EL DOMINIO FINANCIERO
            </a>
          </motion.div>

          <motion.div whileHover={{
          y: -8
        }} className="bg-primary-dark rounded-2xl p-6 md:p-8 border-2 border-gold flex flex-col h-full shadow-[0_15px_40px_rgba(184,146,58,0.2)] relative" data-id="element-189">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-ink font-bold py-1.5 px-6 rounded-full text-xs md:text-sm flex items-center shadow-lg whitespace-nowrap tracking-wide" data-id="element-190">
              <Star className="w-4 h-4 mr-1.5 fill-ink" data-id="element-191" /> MÁS ELEGIDO
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-192">
              <h4 className="text-xl md:text-2xl font-bold text-cream mb-2 flex items-center justify-center font-serif" data-id="element-193">
                <span className="mr-2" data-id="element-194">🏆</span> DOMINIO +
              </h4>
              <p className="text-gold font-bold text-sm md:text-base mb-4" data-id="element-195">
                PORTAFOLIOS MAESTROS 2026
              </p>
              <p className="text-cream/90 text-sm mb-4 font-medium" data-id="element-196">
                6 Tomos + 6 Bonos + Upsell Premium
              </p>
              <div className="bg-black/20 rounded-xl py-3 px-4 inline-block mb-2 border border-white/10" data-id="element-197">
                <p className="text-xs text-gold/80 mb-1 uppercase tracking-wider font-bold" data-id="element-198">
                  Ideal para:
                </p>
                <p className="text-sm font-medium text-cream" data-id="element-199">
                  Personas que quieren ordenar su base Y aprender a multiplicar
                  su capital con los 5 portafolios listos para usar
                </p>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-200">
              <p className="line-through text-base md:text-lg mb-2 text-gold/60 font-medium" data-id="element-201">
                $69.000
              </p>
              <div className="flex items-start justify-center" data-id="element-202">
                <span className="text-xl md:text-2xl text-gold mt-1 mr-1 font-bold" data-id="element-203">
                  $
                </span>
                <span className="text-4xl md:text-6xl font-bold text-gold font-serif" data-id="element-204">
                  27.990
                </span>
                <span className="text-sm md:text-xl text-gold mt-auto mb-2 ml-1 font-bold" data-id="element-205">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://www.digitalbibliotec.online/cart/52265768452378:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#F2D87A] via-[#C9A84C] to-[#8A6E2A] hover:from-[#F5DE8C] hover:via-[#D4B45A] hover:to-[#9A7E36] text-ink border border-[#8A6E2A]/50 font-bold py-4 px-6 rounded-full transition-all text-center text-sm md:text-base shadow-[0_8px_25px_rgba(138,110,42,0.5),inset_0_1px_0_rgba(255,255,255,0.6)] hover:scale-[1.02] active:scale-95" data-id="element-206">
              👉 DOMINIO + PORTAFOLIOS MAESTROS
            </a>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-ink font-medium bg-white py-5 px-8 rounded-2xl border border-border max-w-4xl mx-auto shadow-sm" data-id="element-207">
          <div className="flex items-center" data-id="element-208">
            <Lock className="w-5 h-5 mr-2 text-success" data-id="element-209" /> Pago 100% seguro
          </div>
          <div className="flex items-center" data-id="element-210">
            <Zap className="w-5 h-5 mr-2 text-primary" data-id="element-211" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center" data-id="element-212">
            <Shield className="w-5 h-5 mr-2 text-success" data-id="element-213" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-214">
            <CreditCard className="w-5 h-5 mr-2 text-primary" data-id="element-215" /> Mercado Pago |
            Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </section>;
}